import React, { PropTypes } from 'react';
import { Resource, DownloadLink } from '../../components';

const SecondaryResources = ({ assetsDownloadLink }) => (
  <div className="col-sm-12">
    <h2 className="resource-headline">Badge and Product's Logos</h2>
    <p className="resource-subheadline">
      Lock and Passwordless logos work best on dark backgrounds; Guardian and Webtask’s logos are designed for light backgrounds.
    </p>
    <div className="badge-product-grid">
      <Resource src="https://cdn.auth0.com/website/assets/pages/press/img/resources/auth0-badge-bac0053249.svg" alt="" />
      <Resource src="https://cdn.auth0.com/website/assets/pages/press/img/resources/lock-logo-7551a9d4a7.svg" alt="" />
      <Resource src="https://cdn.auth0.com/website/assets/pages/press/img/resources/passwordless-logo-e6c31b9edb.svg" alt="" />
      <Resource src="https://cdn.auth0.com/website/assets/pages/press/img/resources/guardian-logo-f355280dcb.svg" alt="" />
      <Resource src="https://cdn.auth0.com/website/assets/pages/press/img/resources/webtask-logo-f479cae0f6.svg" alt="" />
    </div>
    <DownloadLink link={assetsDownloadLink} />
  </div>
);

SecondaryResources.propTypes = {
  assetsDownloadLink: PropTypes.string.isRequired
};

export default SecondaryResources;



// WEBPACK FOOTER //
// ./src/pages/press/components/SecondaryResources/SecondaryResources.js